import { render, staticRenderFns } from "./newSocial.vue?vue&type=template&id=0d070616&scoped=true&"
import script from "./newSocial.vue?vue&type=script&lang=js&"
export * from "./newSocial.vue?vue&type=script&lang=js&"
import style0 from "./newSocial.vue?vue&type=style&index=0&id=0d070616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d070616",
  null
  
)

export default component.exports